import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Login.module.css';
import { loginGym } from '../../Redux/Actions/actions';
import { useNavigate } from 'react-router-dom'; // <-- Agrega esto

const Login = () => {
  const dispatch = useDispatch();
  const { loading, error, gym } = useSelector(state => state); // <-- Agrega token
  const navigate = useNavigate(); // <-- Agrega esto

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

useEffect(() => {
  if (gym) {
    navigate('/home');
  }
}, [gym, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginGym(email, password));
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2>Login Gimnasio</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Ingresando...' : 'Ingresar'}
        </button>
        {error && <p className={styles.error}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;